export default __webpack_public_path__ + "static/media/18.1b67793f.png";